import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    errors: []
};

const slice = createSlice({
    name: "errors",
    initialState,
    reducers: {
        addError(state, action) {
            const {error} = action.payload;
            state.errors = [error, ...state.errors];
        },

        resetErrors(state) {
            state.errors = [];
        }
    }
});

export const reducer = slice.reducer;

export const resetErrors = () => dispatch => {
    dispatch(slice.actions.resetErrors());
};

export const addError = error => dispatch => {
    dispatch(slice.actions.addError({error}));
};
